import { useSyncExternalStore } from "react"

/**
 * The single definition of "desktop layout". Mirrored by the `desktop:`
 * Tailwind variant in `src/index.css`; keep the two in sync.
 */
export const DESKTOP_MEDIA_QUERY = "(min-width: 48rem)"

function getMediaQueryList(): MediaQueryList | null {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function")
    return null
  return window.matchMedia(DESKTOP_MEDIA_QUERY)
}

function subscribe(onChange: () => void) {
  const mql = getMediaQueryList()
  if (!mql) return () => {}
  mql.addEventListener("change", onChange)
  return () => mql.removeEventListener("change", onChange)
}

// Defaults to desktop when the query can't be evaluated (SSR, old browsers).
const getSnapshot = () => getMediaQueryList()?.matches ?? true
const getServerSnapshot = () => true

/** True when the desktop layout applies; false for the phone layout. */
export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
